import { Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { AudioRecordingService } from "../../../core/services/recorder-service/recorder.service";
import { DomSanitizer } from "@angular/platform-browser";
import { FinalUserRestService } from "src/providers/final-user-restservice";
import { Observable, delay } from "rxjs";
import { TransferStateService } from "src/services/transfer-state.service";
import { LocalStorageService } from "src/services/local-storage.service";
import { UrlService } from "src/services/url-service";
import { AudioRestService } from "src/providers/audio-restservice";

@Component({
  selector: "app-recorder",
  templateUrl: "./recorder.component.html",
  styleUrls: ["./recorder.component.scss"],
})
export class RecorderComponent implements OnDestroy {
  @Output() onRecorded: EventEmitter<boolean> = new EventEmitter<boolean>();

  isRecording = false;
  recordedTime;
  blobUrl;
  teste;

  contador: number = 0;
  temporizador: any;

  constructor(
    private audioRecordingService: AudioRecordingService,
    private sanitizer: DomSanitizer,
    private _finalUserService: FinalUserRestService,
    private _urlService: UrlService,
    private _localStorageService: LocalStorageService,
    private _audioRestService: AudioRestService
  ) {
    this.audioRecordingService
      .recordingFailed()
      .subscribe(() => (this.isRecording = false));
    this.audioRecordingService
      .getRecordedTime()
      .subscribe((time) => (this.recordedTime = time));
    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.teste = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      document.getElementById('goToResultsPage').click();
    });
  }

  startRecording() {
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecording()
      .then(() => {
        document.getElementById('lightbox').style.display = 'flex';
        this.isRecording = true;
        this.contador = 0;
        this.temporizador = setInterval(() => {
          this.contador++;
          if (this.contador === 61) {
            this.stopRecording();
          }
        }, 1000);
      })
      .catch(error => {
        console.error('Error al iniciar la grabación:', error);
        this.isRecording = false;
      });
    }
  }

  abortRecording() {
    if (this.isRecording) {
      //console.log("Abort");
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      //console.log("Stop");
      clearInterval(this.temporizador);
      this._audioRestService.setBtnDisabled(false);
      this.audioRecordingService.stopRecording();
      this.isRecording = false;
      this.onRecorded.emit(true);
      document.getElementById('lightbox').style.display = 'none';
      this.uploadAudio();
    }
  }

  uploadAudio() {
    let observable = new Observable((observer) => {
      setTimeout(() => {
        observer.next();
        observer.complete();
      }, 1000);
    });
    observable.pipe(delay(1000)).subscribe(() => {
      if (this.teste) {
        let audioBlob = this.teste.blob;
        this._audioRestService
          .uploadAudio(audioBlob)
          .subscribe((result: any) => {
            this._finalUserService
              .addFinalUserAudio(
                Number(this._localStorageService.getItem("id")),
                result.file_url_name.split('/').at(-1)
              )
              .subscribe((result: any) => {
              });
          });
      }
    });
  }

  clearRecordedData() {
    this.blobUrl = null;
    this.onRecorded.emit(false);
  }

  ngOnDestroy(): void {
    this.abortRecording();
  }
}
